import DOMPurify from '../../lib/dompurify/purify.es.js';

/** @module static */

/**
 * Bereinigung von zwischengespeicherten HTML-Fragmenten und Benutzereingaben
 */
 export class OpaccSanitize {

	constructor() {
		this.defaultOpaccConfig = {
			USE_PROFILES: {html: true, svg: true, svgFilters: true},
			 ADD_TAGS: ['use']
		};
	}

	/**
	 *
	 *
	 * @param {*} dirty Zu bereinigender Input
	 * @param {*} config Zusätzliches Konfigurationsobjekt für die Bereinigung
	 * @returns {string} Bereinigter Input
	 */
	 sanitizeContent(dirty, config = null) {
		return DOMPurify.sanitize(dirty, Object.assign(this.defaultOpaccConfig, config));
	}

	/**
	 *
	 *
	 * @returns {Array} Alle entfernte Elemente und Attribute (Nur zu DEBUG zwecken)
	 */
	removedContent() {
		return DOMPurify.removed;
	}
 }